<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        冷柜基础信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            @click="$router.push('/baseFreezerEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <e6Select
              :dataList="storeFreezerTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="storeFreezerTreeSelect"
              :placeholder="'冷柜名称'"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.regisArea">
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
          <el-form-item prop="forms.freezerTypeList">
            <el-select
              v-model="slotForms.forms.freezerTypeList"
              collapse-tags
              filterable
              multiple
              clearable
              value-key="dicId"
              placeholder="冷柜类型"
            >
              <el-option
                v-for="item in freezerTypeLists"
                :key="item.dicId"
                :label="item.dicName"
                :value="item.dicId"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="125"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/baseFreezerEdit',
                query: {
                  pageType: '2',
                  id: scope.row.freezerId,
                  provinceId: scope.row.provinceId
                }
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import e6City from "e6city";
import {
  FetchStoreFreezerTree,
  DeleteFreezerInfoByIds
} from "@/api/base/freezer";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";

export default {
  components: { e6City },
  mixins: [listInit, operationManage],
  data() {
    return {
      isSearch: false,
      storeFreezerTreeList: [],
      formExtend: {
        forms: {
          comparyName: "",
          freezerName: "",
          countyNameId: "",
          freezerTypeList: [],
          // provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provinceName: "",
          // cityName: $GLOBAL_CONFIG.e6City.cityName,
          cityName: "",
          countyName: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      freezerTypeLists: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      errMess: "",
      tableLoading: "false",
      idList: [],
      isFirstLoad: true,
      // 请求表格数据
      tableDataUrl: "/base/freezer/findByPage",
      //导出URL
      exportUrl: "/base/freezer/exportFreezerList?"
    };
  },
  created() {
    this.initServiceObjectSelect();
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  mounted() {
    let idStr = this.$route.query.freezerIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
    //初始化区位树
    this.initStoreFreezerTree();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    /**
     *  初始化冷柜类型字典列表
     */
    initServiceObjectSelect() {
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({
            dicTypeKey: "freezer_type"
          })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.freezerTypeLists = e.data.result;
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    //初始化区位树
    initStoreFreezerTree() {
      FetchStoreFreezerTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.storeFreezerTreeList = response.result;
            this.$nextTick(() => {
              this.$refs.storeFreezerTreeSelect.setSelectList(this.idList);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取选中区位id
    getStoreFreezerIdListParam() {
      let selected = this.$refs.storeFreezerTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeleteFreezerInfoByIds({
            ids: row.freezerId
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 整合查询数据
    mergeObj() {
      let storeFreezerIdList;
      if (this.isFirstLoad) {
        storeFreezerIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        storeFreezerIdList = this.getStoreFreezerIdListParam();
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        storeFreezerIdList: storeFreezerIdList,
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    //重置
    handleResetForm() {
      this.$refs.storeFreezerTreeSelect.multipleRemoveAll();
      this.$refs.e6City.clearCity();
      this.formExtend.forms.provinceName = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.countyName = "";
    },
    handleExportClick() {
      let storeFreezerIdList;
      if (this.isFirstLoad) {
        storeFreezerIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        storeFreezerIdList = this.getStoreFreezerIdListParam();
      }
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&freezerName=" + this.formExtend.forms.freezerName;
      param += "&freezerTypeList=" + this.formExtend.forms.freezerTypeList;
      param += "&storeFreezerIdList=" + storeFreezerIdList;
      param += "&countyNameId=" + this.formExtend.forms.countyNameId;
      param += "&provinceName=" + this.formExtend.forms.provinceName;
      param += "&cityName=" + this.formExtend.forms.cityName;
      param += "&countyName=" + this.formExtend.forms.countyName;
      document.location.href = this.exportUrl + param;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
